import styled from 'styled-components'

import theme from '../../theme'

const ButtonContainer = styled.span`
  button {
    text-shadow: none;
    box-shadow: none;
    cursor: pointer;
    border: 1px solid ${theme.colors.primary};
    background: ${theme.colors.white};
    color: ${theme.colors.primary};

    &:hover {
      background: ${theme.colors.primary};
      color: ${theme.colors.white};
    }
  }

  .bold {
    font-weight: 600;
  }

  .low {
    height: 32px;
    padding: 5px;
  }

  .high {
    height: 80px;
    padding: 24px;
    font-size: 20px;
    line-height: 26px;
  }
`

export { ButtonContainer }
